"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var history_1 = require("history");
var react_dom_1 = tslib_1.__importDefault(require("react-dom"));
function render(renderer, id) {
    var containerId = id + "-container";
    if (document.getElementById(containerId)) {
        window[id + "Render"] = function (history, containedAppProps) {
            react_dom_1["default"].render(renderer(history, containedAppProps), document.getElementById(containerId));
        };
        window[id + "Unmount"] = function () {
            react_dom_1["default"].unmountComponentAtNode(document.getElementById(containerId));
        };
    }
    else {
        react_dom_1["default"].render(renderer(history_1.createBrowserHistory()), document.getElementById('root'));
    }
}
exports["default"] = render;
//# sourceMappingURL=render.js.map